"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMode = exports.changeMode = exports.getMode = exports.Modes = void 0;
const react_1 = __importDefault(require("react"));
const utils_1 = require("../utils");
const attrModeName = 'mode';
var Modes;
(function (Modes) {
    Modes["default"] = "default";
    Modes["dark"] = "dark";
})(Modes = exports.Modes || (exports.Modes = {}));
const modeStore = (store = localStorage) => ({
    set: (value) => store.setItem(attrModeName, value),
    get: () => store.getItem(attrModeName),
});
const getMode = () => (modeStore().get() || (0, utils_1.getAttrValue)(attrModeName, Modes.default));
exports.getMode = getMode;
const changeMode = (value = Modes.default) => {
    modeStore().set(value);
    (0, utils_1.changeAttrValue)(attrModeName, value);
};
exports.changeMode = changeMode;
const useMode = () => {
    const [mode, setMode] = react_1.default.useState((0, exports.getMode)());
    react_1.default.useEffect(() => {
        (0, utils_1.changeAttrValue)(attrModeName, mode);
        const disconnect = (0, utils_1.onChangeAttr)(attrModeName, setMode, Modes.default);
        return () => disconnect();
    }, []);
    return [mode, exports.changeMode];
};
exports.useMode = useMode;
//# sourceMappingURL=useMode.js.map